export { default } from './BaseHead'
